var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toast } from '@/components';
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, } from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from './theme-context';
var ToastContext = createContext(undefined);
export var ToastProvider = function (_a) {
    var children = _a.children, _b = _a.maxVisibleToasts, maxVisibleToasts = _b === void 0 ? 3 : _b;
    var _c = useState([]), toasts = _c[0], setToasts = _c[1];
    var theme = useTheme().theme;
    var containerRef = useRef(null);
    var toastRoot = useMemo(function () {
        var toastRoot = document.getElementById('toast-root') || document.createElement('div');
        if (!toastRoot.parentElement) {
            toastRoot.id = 'toast-root';
            document.documentElement.appendChild(toastRoot);
        }
        containerRef.current = toastRoot;
        return toastRoot;
    }, []);
    useEffect(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (!container)
            return;
        var setThemeProperties = function (obj, prefix) {
            if (prefix === void 0) { prefix = ''; }
            Object.entries(obj).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (typeof value === 'object' && value !== null) {
                    setThemeProperties(value, "".concat(prefix).concat(key, "-"));
                }
                else {
                    container.style.setProperty("--".concat(prefix).concat(key), String(value));
                }
            });
        };
        setThemeProperties(theme);
    }, [theme, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    var removeToast = useCallback(function (toastId) {
        setToasts(function (prevToasts) { return prevToasts.filter(function (toast) { return toast.id !== toastId; }); });
    }, []);
    var showToast = useCallback(function (_a) {
        var message = _a.message, description = _a.description, status = _a.status, theme = _a.theme;
        var id = Date.now();
        setToasts(function (prevToasts) {
            var newToasts = __spreadArray(__spreadArray([], prevToasts, true), [{ id: id, message: message, description: description, status: status, theme: theme }], false);
            if (newToasts.length > maxVisibleToasts) {
                newToasts.shift();
            }
            return newToasts;
        });
        setTimeout(function () {
            removeToast(id);
        }, 5000);
    }, [maxVisibleToasts, removeToast]);
    var value = {
        showToast: showToast,
    };
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, createPortal(_jsx("div", { className: 'fixed right-2 z-100051 top-2', children: toasts.map(function (toast) { return (_jsx(Toast, { id: toast.id, message: toast.message, description: toast.description, status: toast.status, removeToast: removeToast }, toast.id)); }) }), toastRoot)] }));
};
export var useToast = function () {
    var context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
